import CallAPI from "@/functions/Cl_api";
import { Cl_common } from "@/functions/Cl_common";
import { DtoClaimRakurakuHistorysGetReqImple } from "mediadept-common/src/common/dto/DtoClaimRakurakuHistorysGetReqImple";
import { DtoClaimRakurakuHistorysGetResImple } from "mediadept-common/src/common/dto/DtoClaimRakurakuHistorysGetResImple";
import { DtoClaimRakurakuHistorysPostReq } from "mediadept-common/src/common/dto/abst/DtoClaimRakurakuHistorysPostReq";
import { DtoClaimRakurakuHistorysPostRes } from "mediadept-common/src/common/dto/abst/DtoClaimRakurakuHistorysPostRes";
import { DtoClaimRakurakuHistorysPutReq } from "mediadept-common/src/common/dto/abst/DtoClaimRakurakuHistorysPutReq";
import { DtoClaimRakurakuHistorysPutRes } from "mediadept-common/src/common/dto/abst/DtoClaimRakurakuHistorysPutRes";
import { DtoClaimRakurakuHistorysDeleteReq } from "mediadept-common/src/common/dto/abst/DtoClaimRakurakuHistorysDeleteReq";
import { DtoClaimRakurakuHistorysDeleteRes } from "mediadept-common/src/common/dto/abst/DtoClaimRakurakuHistorysDeleteRes";

export class Cl_claimrakurakuhistory {
  public static async getList(
    dto: DtoClaimRakurakuHistorysGetReqImple
  ): Promise<DtoClaimRakurakuHistorysGetResImple> {
    return Object.assign(
      new DtoClaimRakurakuHistorysGetResImple(),
      await CallAPI.getRequest(
        "/claimrakurakuhistorys?" +
          Cl_common.cnvObj2GetParam(dto.pager) +
          "&" +
          Cl_common.cnvObj2GetParam(dto)
      )
    );
  }

  public static async get(
    dto: DtoClaimRakurakuHistorysGetReqImple
  ): Promise<DtoClaimRakurakuHistorysGetResImple> {
    return Object.assign(
      new DtoClaimRakurakuHistorysGetResImple(),
      await CallAPI.getRequest(
        "/claimrakurakuhistorys/" + dto.c_claim_rakuraku_history_id
      )
    );
  }

  public static async post(
    dto: DtoClaimRakurakuHistorysPostReq
  ): Promise<DtoClaimRakurakuHistorysPostRes> {
    return Object.assign(
      new DtoClaimRakurakuHistorysPostRes(),
      await CallAPI.postRequest("/claimrakurakuhistorys", dto)
    );
  }

  public static async put(
    dto: DtoClaimRakurakuHistorysPutReq
  ): Promise<DtoClaimRakurakuHistorysPutRes> {
    return Object.assign(
      new DtoClaimRakurakuHistorysPutRes(),
      await CallAPI.putRequest(
        "/claimrakurakuhistorys/" + dto.c_claim_rakuraku_history_id,
        dto
      )
    );
  }

  public static async del(
    dto: DtoClaimRakurakuHistorysDeleteReq
  ): Promise<DtoClaimRakurakuHistorysDeleteRes> {
    return Object.assign(
      new DtoClaimRakurakuHistorysDeleteRes(),
      await CallAPI.deleteRequest(
        "/claimrakurakuhistorys/" + dto.c_claim_rakuraku_history_id
      )
    );
  }
}
